/* eslint-disable camelcase */
import KickImage from 'Reuseables/KickImage';
import { useState } from 'react';
import { connect } from 'react-redux';

// ========= modules component import section ========= //
import * as _ from 'lodash';
import { IconContext } from 'react-icons';
import ReactLoading from 'react-loading';
import moreIcon from '../../../images/more.png';
// ====== end of modules component import section ====== //

// ========= project component import section ========= //
import TableHeader from '../components/TableHeader';
// ====== end of project component import section ====== //

// ========= action import section ========= //
// ====== end of action import section ====== //

// ========= interface import section ========= //
import moment from 'moment';
import { BidInterface } from '../../../interface/bid';
import DataHistoryInterface from '../../../interface/reducers/history';
import { ShippingInterface } from '../../../interface/shipping';
import {
  ADMINISTRATOR,
  EXPIRED,
  ON_COURIER,
  ON_DONE,
  UNDER_REVIEW,
  _COMPLETED,
  _DONE_BY_ADMIN,
  _DONE_BY_BUYER,
  _DONE_BY_CRON,
  _KA_RECEIVED,
  _NEW,
  _ON_CANCEL,
  _PENDING_PAYMENT,
  _PENDING_REFUND,
  _REFUNDED,
  _SELLER_SENT,
  _SENT_BUYER,
  _VERIFIED_FAIL,
  _VERIFIED_PASS,
  _VERIFYING_BID,
  _VERIYING_PAYMENT,
  remaining_time
} from '../../../utils';
import ModalHistory from '../components/ModalHistory';
// ====== end of interface import section ====== //

const moreIconNew: any = moreIcon;

type stateToProps = {
  dataHistory: DataHistoryInterface;
  dataAuth: AuthInterface;
};

interface HistoryInterface extends stateToProps {
  callbackAfterUpdate: () => any;
  loading: boolean;
  userCurrency: UserCurrencyInterface;
}

import { useEffect } from 'react';
import EMPTY_STATE from '../../../images/dashboard-empty-state.jpg';
import AuthInterface, {
  UserCurrencyInterface,
} from '../../../interface/reducers/auth';
import { formatCurrency, handleImageCategory } from '../../../utils/Helpers';

const sneakerCondition = (condition: string) => {
  switch (condition) {
    case 'BARU':
      return 'Brand New';
    case 'BEKAS':
      return 'Used';
    case 'PRISTINE':
      return 'Pristine';
    case 'GOOD':
      return 'Good';
    case 'WELL_USED':
      return 'Well Used';
    case 'LIKE_NEW':
      return 'Like New';
    case 'VINTAGE':
      return 'Vintage';
    default:
      return 'Brand New';
  }
};

const box = (condition: string) => {
  switch (condition) {
    case 'SEMPURNA':
      return 'Perfect Box';
    case 'CACAT':
      return 'Damaged Box';
    case 'NO_BOX':
      return 'Missing Box';

    default:
      return 'Perfect Box';
  }
};

const accessories = (condition: boolean) => {
  if (condition) {
    return 'Missing Accessories';
  } else {
    return 'Complete Accessories';
  }
};

const defectCondition = (bool: boolean, data: any) => {
  switch (bool) {
    case true:
      return detailCondition(data);
    case false:
      return (
        <div>
          <span>
            {sneakerCondition(data.sneakers_condition)} / Perfect Condition
          </span>
        </div>
      );

    default:
      return 'Perfect Condition';
  }
};

const detailCondition = (data: any) => {
  const condition = data.user_sell.defects
    .filter((item: any) => item.value)
    .map((item: any) => item.display_name)
    .join(' / ');

  return (
    <div>
      <span>
        {sneakerCondition(data.sneakers_condition)} / {condition}
      </span>
    </div>
  );
};

const detailHandbagCondition = (data: any) => {
  const condition = data
    .filter((item: any) => item.value)
    .map((item: any) => item.display_name)
    .join(' / ');

  return condition;
};

const handbagCondition = (data: any) => {
  return detailHandbagCondition(data);
};

const boxHandbag = (value: boolean) => {
  if (value) {
    return '';
  } else {
    return 'Missing Box';
  }
};

const dustBag = (value: boolean) => {
  if (value) {
    return '';
  } else {
    return 'KA Dust Bag';
  }
};

const _sellerToBuyer = ({
  status,
  seller_responded,
  customer_received,
  completed,
  ka_sent,
  seller_awb_number,
}: any) => {
  switch (status) {
    case _NEW[0]:
      return seller_responded ? ON_COURIER[3] : _NEW[2];
    case _SELLER_SENT[0]:
      return seller_awb_number ? _SELLER_SENT[2] : ON_COURIER[3];
    case _ON_CANCEL[0]:
      return _ON_CANCEL[2];
    case _KA_RECEIVED[0]:
      return _KA_RECEIVED[1];
    case _VERIFIED_PASS[0]:
      return _VERIFIED_PASS[2];
    case _VERIFIED_FAIL[0]:
      return _VERIFIED_FAIL[2];
    case _SENT_BUYER[0]:
      return ka_sent ? _SENT_BUYER[2] : 'Awaiting shipment';
    case _DONE_BY_BUYER:
      return ON_DONE[1];
    case _DONE_BY_ADMIN:
      return ON_DONE[1];
    case _DONE_BY_CRON:
      return ON_DONE[1];
    case UNDER_REVIEW[0].toUpperCase():
      return UNDER_REVIEW[1];
    default:
      return ADMINISTRATOR[1];
  }
};

const _getStatusPurchase = ({ sale, status, expiry }: any) => {
  if (
    remaining_time(expiry).distance < 0 &&
    (status === _PENDING_PAYMENT[0] || status === _VERIFYING_BID[0])
  ) {
    return EXPIRED[2];
  }

  switch (status) {
    case _PENDING_PAYMENT[0]:
      return _PENDING_PAYMENT[2];
    case _VERIYING_PAYMENT[0]:
      return _VERIYING_PAYMENT[2];
    case _COMPLETED:
      return _sellerToBuyer(sale[0]);
    case ON_COURIER:
      return ON_COURIER[1];
    case ON_DONE:
      return ON_DONE[1];
    case _ON_CANCEL[0]:
      return `Payment ${_ON_CANCEL[2]}`;
    case _PENDING_REFUND[0]:
      return _PENDING_REFUND[2];
    case _REFUNDED[0]:
      return _REFUNDED[2];
    case EXPIRED[0]:
      return EXPIRED[2];
    case _VERIFYING_BID[0]:
      return _VERIFYING_BID[2];
    default:
      return ADMINISTRATOR[1];
  }
};
export interface HistoryDetailData {
  brandName: string;
  displayName: string;
  SKU: string;
  size: number;
  paymentMethod: string;
  imageUrl: string;
  boxCondition: any;
  displayItem: any;
  missingAccessories: any;
  sneakersCondition: any;
  sneakersDefect: any;
  yellowing: boolean;
  totalAmount: number;
  streetAddress: string;
  category: string;
  defects: any;
  status: string;
  bankCode: any;
  invoiceNumber: string;
  invoiceUrl: string;
  paymentVia: string;
  totalAdjustedAmount: string;
  saleStatus: string;
  buyingPrice: string;
  expired: string;
  purchasedDate: string;
  shippingCourier: string;
  AWB: string;
  hideBoxInfo: boolean;
  isVintage: boolean;
  shipping: ShippingInterface;
  datePurchase: string;
  trackingData: {
    orderId: string;
    shippingCourier: string;
  };
}

/**
 * History tab on Buying User Dashboard section for Kick Avenue 3.0 Website.
 * Author: Rifqy Zacky Ariadhy (rifqyzackya@gmail.com)
 * ===============================================
 * @param {HistoryInterface} props for this component.
 * @return {JSX.Element}
 */
function HistoryTab({
  dataHistory,
  callbackAfterUpdate,
  loading,
  userCurrency,
}: HistoryInterface): JSX.Element {
  const [historyDetailData, setHistoryDetailData] = useState<
    HistoryDetailData | {}
  >({});
  const [isModalDetailOpened, setModalDetailOpened] = useState(false);
  const [historyData, setHistoryData] = useState(null);
  const toggleModalDetail = () => setModalDetailOpened(!isModalDetailOpened);
  /**
   * Table item for History List in Buying Dashboard
   * @param {BidInterface} item
   * @return {JSX.Element}
   */
  function renderItemHistory(item: BidInterface): JSX.Element {
    const category = item.user_sell.product_variant.product.category.name;
    const uniqueDefects =
      item.user_sell === null ? [] : _.uniqBy(item.user_sell.defects, 'name');
    const dustBagCondition = uniqueDefects
      ? uniqueDefects.find((a: any) => a.name === 'DUST_BAG')
      : {};
    const boxCondition = uniqueDefects
      ? uniqueDefects.find((a: any) => a.name === 'BOX')
      : {};
    const hideBoxInfo = item.user_sell.product_variant.hide_box_info;
    const isVintage = item.user_sell.product_variant.vintage;
    const luxuryDetailArr = [
      sneakerCondition(item.sneakers_condition),
      accessories(item.missing_accessories),
      dustBag(dustBagCondition),
      hideBoxInfo ? '' : boxHandbag(boxCondition),
      item.sneakers_defect ? handbagCondition(uniqueDefects) : '',
    ];
    const luxuryDetail = luxuryDetailArr
      .filter((item) => item !== '' && item !== 'Missing Box')
      .map((item) => item)
      .join(' / ');
    const isTicket = item.user_sell.product_variant.product.name.includes('Ticket');
    const clickedDetail = () => {
      setHistoryDetailData({
        brandName:
          category === 'lifestyles'
            ? item.user_sell.product_variant.product.brand
              ? item.user_sell.product_variant.product.brand.name
              : item.user_sell.product_variant.product.name
            : item.user_sell.product_variant.product.brand
            ? item.user_sell.product_variant.product.brand.flat[0]
            : item.user_sell.product_variant.product.name,
        displayName: item.user_sell.product_variant.display_name,
        SKU: item.user_sell.product_variant.SKU,
        size: item.user_sell.size.US,
        paymentMethod: item.payment_method,
        imageUrl: item.user_sell.product_variant.product_variant_images.length
          ? item.user_sell.product_variant.product_variant_images[0].URL
          : null,
        boxCondition: item.user_sell.box_condition,
        displayItem: item.user_sell.display_item,
        missingAccessories: item.user_sell.missing_accessories,
        sneakersCondition: item.user_sell.sneakers_condition,
        sneakersDefect: item.user_sell.sneakers_defect,
        yellowing: item.user_sell.yellowing,
        totalAmount: item.actual_total_amount,
        streetAddress: item.shipping.street_address,
        category,
        defects: item.user_sell.defects,
        status: item.status,
        bankCode: item.bank_code,
        invoiceNumber: item.invoice_number,
        invoiceUrl: item.invoice_url,
        paymentVia: item.payment_via,
        totalAdjustedAmount: item.total_adjusted_amount,
        saleStatus:
          _getStatusPurchase(item) === _VERIFIED_FAIL[2]
            ? _VERIFIED_FAIL[3]
            : _getStatusPurchase(item),
        buyingPrice: item.total_amount,
        expired: item.expired,
        purchasedDate: item.sale.length ? item.sale[0].customer_paid : '-',
        datePurchase: item.created_at,
        shippingCourier: item.sale.length
          ? item.sale[0].sale_shipping.ka_courier
          : '-',
        AWB: item.sale.length ? item.sale[0].sale_shipping.awb_number : '-',
        hideBoxInfo: item.user_sell.product_variant.hide_box_info,
        isVintage: item.user_sell.product_variant.vintage,
        shipping: item.shipping,
        trackingData: {
          orderId: item.invoice_number,
          shippingCourier: item.sale.length
            ? item.sale[0].sale_shipping.ka_courier
            : '-',
        isTicket,
        },
      });
      toggleModalDetail();
    };

    return (
      <div className={'item-table'}>
        <div className={'product-container history'}>
          <KickImage
            src={handleImageCategory(isTicket, category.toLowerCase())}
            className={'image-category'}
          />
          <div>
            <p className={'title'}>
              {item?.user_sell?.product_variant?.display_name}
            </p>
            {category === 'handbags' ||
            (category === 'lifestyles' &&
              item.user_sell.size.US.toLowerCase() !==
                'all size') ? (
              <div className={'size-container'}>
                <p>{item.user_sell.size.US}</p>
              </div>
            ) : (
              <div className={'size-container'}>
                <p>US {item.user_sell.size.US}</p>
              </div>
            )}
            <p className={'condition'}>{item.invoice_number}</p>
            <p className={'extra'}>
              {item?.user_sell?.product_variant?.colour}
            </p>
            {item.user_sell.pre_order ? (
              <div className={'pre-order-wrapper'}>
                <p className={'pre-order'}>Pre-Order</p>
              </div>
            ) : null}
            {/* <p className={'condition'}>
              {isVintage
                ? 'Vintage'
                : item.user_sell.product_variant.product.category.name ===
                    'sneakers' ||
                  item.user_sell.product_variant.product.category.name ===
                    'lifestyles'
                ? `${sneakerCondition(item.sneakers_condition)} /  ${box(
                    item.box_condition,
                  )} / ${accessories(item.missing_accessories)}`
                : item.user_sell.product_variant.product.category.name ===
                  'apparels'
                ? defectCondition(item.sneakers_defect, item)
                : luxuryDetail}
            </p> */}
          </div>
        </div>
        <div className={'purchased-container'}>
          <span>{moment(item.created_at).format('MMMM DD, YYYY')}</span>
        </div>
        <div className={'status-inprogress-container'}>
          <div className={'price-container'}>
            <p className={'status-text'}>{_getStatusPurchase(item)}</p>
            {_getStatusPurchase(item) === _COMPLETED && (
              <span>
                {formatCurrency(
                  item.total_adjusted_amount,
                  userCurrency.ratio,
                  userCurrency.currency,
                )}
              </span>
            )}
          </div>
          <div className={'button-container'}>
            <IconContext.Provider value={{ color: '#242424', size: '15px' }}>
              <div className={'icon-container'} onClick={clickedDetail}>
                {/* <MdSettings /> */}
                <KickImage src={moreIconNew} alt="..." />
              </div>
            </IconContext.Provider>
          </div>
        </div>
      </div>
    );
  }

  /**
   * Rendering Empty State UI
   * @return {JSX.Element}
   */
  function renderEmpty() {
    return (
      <div className={'empty-container'}>
        <KickImage src={EMPTY_STATE} />
        <p>It seems you haven’t got anything on purchasing.</p>
        <div className={'button-refresh'} onClick={callbackAfterUpdate}>
          <p>Refresh</p>
        </div>
      </div>
    );
  }

  useEffect(() => {
    setHistoryData(dataHistory);
  }, [dataHistory]);
  return (
    <div>
      <TableHeader
        getData={callbackAfterUpdate}
        type={'history'}
        mode={'buying'}
      />
      <div className={'table-container'}>
        <div className={'header-table'}>
          <div className={'product-container history'}>
            <span>Product</span>
          </div>
          <div className={'purchased-container history'}>
            <span>Purchase Date</span>
          </div>
          <div className={'status-inprogress-container history'}>
            <span>Status</span>
          </div>
        </div>

        <div className={'body-table'}>
          {!historyData || historyData.pembelianCompleted.isFetch || loading ? (
            <div className={'empty-container'}>
              <ReactLoading
                type={'spin'}
                height={50}
                width={50}
                color={'#159953'}
              />
            </div>
          ) : historyData?.pembelianCompleted?.dataPembelian?.length > 0 ? (
            historyData.pembelianCompleted.dataPembelian.map((item) =>
              renderItemHistory(item),
            )
          ) : (
            renderEmpty()
          )}
        </div>
      </div>

      <ModalHistory
        isOpen={isModalDetailOpened}
        onToggle={toggleModalDetail}
        data={historyDetailData}
        currency={userCurrency}
      />
    </div>
  );
}

const mapStateToProps = (state: stateToProps) => {
  return {
    dataHistory: state.dataHistory,
    userCurrency: state.dataAuth.userCurrency,
  };
};

const mapDispatchToProps = (dispatch: (arg0: any) => any) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(HistoryTab);
